'use client';

import Image from 'next/image';
import Link from 'next/link';
import {useCallback} from 'react';

import LinkIcon from '@web-landing/assets/icons/right_outline.svg';

import {breadcrumbsTestIds} from '@web-landing/constants/test-ids/mainLandingTestIds';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';
import {emitYmEvent} from '@web-landing/analytics/helpers/ymEvent';

import {EVENTS} from '@web-landing/analytics/events';

import styles from './BreadcrumbItem.module.scss';
import {BreadcrumbsBackstackItem} from './types';

type Props = {
  item: BreadcrumbsBackstackItem;
  position: number;
  isLast?: boolean;
};

export const BreadcrumbItem = ({item, position, isLast = false}: Props) => {
  const onClick = useCallback(() => {
    emitYmEvent('appPage_breadCrumbs_click');

    logTmrEvent(EVENTS.breadcrumbsClick, {
      button_text: item.title,
    });
  }, [item.title]);

  return (
    <li
      itemProp="itemListElement"
      itemScope
      itemType="https://schema.org/ListItem"
      className={styles.listItem}
    >
      <Link
        href={item.path}
        className={styles.link}
        itemProp="item"
        onClick={onClick}
        data-testid={breadcrumbsTestIds.link}
      >
        <span className={styles.linkText} itemProp="name">
          {item.title}
        </span>
        <meta itemProp="position" content={`${position}`} />
      </Link>
      {!isLast && (
        <Image
          src={LinkIcon.src}
          className={styles.chevron}
          width="20"
          height="20"
          alt="chevron"
        />
      )}
    </li>
  );
};
